export const randomNum = function (number) { return Math.floor(Math.random() * number) }
